export default __webpack_public_path__ + "static/media/mob_preland_1.fa12ce5a.jpg";